import { errorCodes, getUserFriendlyErrorMessage } from '@/utils/errormessages'
import { apiErrorCodes } from '@/utils/apiHelper'

/**
 * Maps an API error body (the parsed server response) to the user-facing message string,
 * reproducing the exact branching the old StateSettingsActions `getErrorMessage` used in the
 * SAVE_STATE_SETTINGS_ERROR listener case.
 */
export function getStateSettingsErrorMessage(body: unknown): string {
  const errorBody = body && typeof body === 'object' ? body : {}

  const rawCode = 'UserFriendlyErrorCode' in errorBody ? errorBody.UserFriendlyErrorCode : undefined
  const userFriendlyErrorCode = typeof rawCode === 'string' || typeof rawCode === 'number' ? rawCode : undefined
  const rawExtra = 'extra' in errorBody ? errorBody.extra : undefined
  const extra = typeof rawExtra === 'string' ? rawExtra : undefined

  if (userFriendlyErrorCode || userFriendlyErrorCode === '') {
    return userFriendlyErrorCode ? getUserFriendlyErrorMessage(userFriendlyErrorCode, undefined, extra) : ''
  }

  const errorCode = 'ErrorCode' in errorBody ? errorBody.ErrorCode : undefined

  switch (errorCode) {
    case apiErrorCodes.STATE_CODE_NOT_VALID:
      return getUserFriendlyErrorMessage(errorCodes.NOT_VALID_VALUE, undefined, 'State')
    default:
      return getUserFriendlyErrorMessage(errorCodes.DEFAULT)
  }
}
